(function () {
  'use strict';

  function LandingController ($state, Common, $rootScope, $localStorage, $window, Translation) {
    const vm = this;

    function goTo (state, option) {
      const currentType = Common.get('serviceType', null);
      if (currentType !== option) { //clear all data if we switch from one order type to another
        Common.resetOrderData();
      }
      Common.set('serviceType', option);
      $state.go(state);
    }

    function isProd () {
      const stage = web2print.env.stage;
      return stage === 'prod';
    }

    function isTest () {
      return web2print.env.stage === 'test';
    }

    function isActive (type) {
      return $state.current.name === type;
    }

    function isNCPUser () {
      return $rootScope.isNCPUser();
    }

    function getTypeDescription () {
      const description = {
        'main.landing': 'LANDING_PAGE_INFORMATION_MEMBERSHIP_DESCRIPTION',
        'main.admail': 'LANDING_PAGE_ADMAIL_DESCRIPTION',
      };

      return description[$state.current.name];
    }

    function isBannerClosed () {
      return pnTopbar.isLoggedIn || vm.bannerClosed;
    }

    function getInformationCategory () {
      if (pnTopbar.market === 'DK') {
        return 'DKLetters';
      }
      return 'information';
    }

    function hideBanner () {
      $localStorage.closeBanner = true;
      vm.bannerClosed = true;
    }

    function goToODR (state, option) {
      if (isNCPUser()) {
        goTo(state, option);
      } else {
        showTeaser('odr');
      }
    }

    // this is to render html tags
    function getTranslation (key) {
      return Translation.translate(key).value;
    }

    function getMarket () {
      return $rootScope.market;
    }

    function showTeaser (product) {
      vm.teaserData = {
        show: true,
        product: product,
        isLoggedIn: pnTopbar.isLoggedIn,
        isAgreementUser: isNCPUser()
      };
    }

    function activate () {
      // models
      vm.isEditing = false;
      vm.fromState = false;
      vm.bannerClosed = $localStorage.closeBanner || false;
      vm.createLink = web2print.env.createAccount;

      // functions
      vm.goTo = goTo;
      vm.isProd = isProd;
      vm.isActive = isActive;
      vm.isNCPUser = isNCPUser;
      vm.getTypeDescription = getTypeDescription;
      vm.correctLogin = $rootScope.correctLogin;
      vm.hideBanner = hideBanner;
      vm.isBannerClosed = isBannerClosed;
      vm.isTest = isTest;
      vm.getTranslation = getTranslation;
      vm.getMarket = getMarket;
      vm.getInformationCategory = getInformationCategory;
      vm.goToODR = goToODR;

      // Feature toggles
      vm.odr = true; // FeatureToggleFactory.isFeatureEnabled('odr'); // having issues with feature toggling
      // END Feature toggles

      // Product Teaser
      vm.teaserData = {
        show: false,
        product: '',
        isLoggedIn: pnTopbar.isLoggedIn,
        isAgreementUser: isNCPUser()
      };
    }

    function checkSession () {
      if (Common.get('paymentStatus', false) === 'SUCCESS') {
        Common.resetOrderData();
      }

      activate();
    }


    checkSession();
  }

  angular.module('web2print.landing')
    .controller('LandingController', LandingController);

  LandingController.$inject = ['$state', 'Common', '$rootScope', '$localStorage', '$window', 'Translation'];
})();
